import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import { Header, McMenu, SelectionBrowser } from '../components/';
import { Card } from '@salesforce/design-system-react';

import * as Shapes from '../constants/shapes';

export class SelectionDashboard extends Component {
  componentDidMount() {
    this.props.actions.getRules();
  }

  render() {
    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/analytics/selections"
      >
        <BrandBand>
          <Header route={this.props.match} />
          <div>
            <Card hasNoHeader>
              <SelectionBrowser
                actions={this.props.actions}
                flags={this.props.flags.flags}
                rules={this.props.rules}
                selections={this.props.selections}
                history={this.props.history}
              />
            </Card>
          </div>
        </BrandBand>
      </McMenu>
    );
  }
}

SelectionDashboard.contextTypes = {
  router: PropTypes.object
};

SelectionDashboard.propTypes = {
  actions: PropTypes.object,
  flags: Shapes.Flags,
  rules: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    flags: state.ecs.flags,
    rules: state.ecs.rules,
    selections: state.ecs.selections
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionDashboard);
